export default "__VITE_ASSET__Bxn391vj__"